export const controls_button_animation = {
    whileHover: { backgroundColor: "#afb9b9" },
};

export const controls_animation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
};
